// ============================================================
// ASSISTING - what a helper is worth.
//
// Somebody helping with a test adds a bonus to it. How much is the table's
// ruling (`assistBonus`): +10 as written, or +5 or +20. One number, read by
// a called test's helpers and by the helpers of a group approach.
//
// Pure. Zero React dependency.
// ============================================================

export const ASSIST_BONUSES = [
  { key: '5', label: '+5 each' },
  { key: '10', label: '+10 each', hint: 'As written.' },
  { key: '20', label: '+20 each' },
] as const;

export type AssistBonusKey = (typeof ASSIST_BONUSES)[number]['key'];
export const DEFAULT_ASSIST_BONUS: AssistBonusKey = '10';

export const isAssistBonus = (value: unknown): value is AssistBonusKey =>
  ASSIST_BONUSES.some((choice) => choice.key === value);

/** The most helpers a test takes. More hands than this get in each other's way. */
export const MAX_ASSISTS = 4;

/** A count of helpers held to what a test takes; anything that is not a count is none. */
export function clampAssists(value: unknown): number {
  const n = typeof value === 'number' && Number.isFinite(value) ? Math.floor(value) : 0;
  return Math.max(0, Math.min(MAX_ASSISTS, n));
}

/** What `assists` helpers add, under the table's ruling. */
export const assistMod = (assists: unknown, bonus: number): number => clampAssists(assists) * bonus;
